import { CircleX } from "lucide-react"

import { Icon, IconSizes } from "../../../Icon"

interface LabelErrorProps {
  errorMessage: string | undefined
  inputId?: string
}

export function LabelError({ errorMessage, inputId }: LabelErrorProps) {
  if (!errorMessage) return null
  return (
    <label
      htmlFor={inputId}
      className="text-body color-danger my-1 flex items-center gap-x-1"
    >
      <Icon icon={CircleX} size={IconSizes.ExtraSmall} />
      {errorMessage}
    </label>
  )
}
